module.exports = __webpack_public_path__ + "img/LIGHT4J.fb130b0f.png";